import React from 'react'

export default function TikTokIcon () {
  return (
    <svg
      width='17'
      height='16'
      viewBox='0 0 17 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_200_8984)'>
        <path
          d='M15.5008 6.55969C14.125 6.56298 12.783 6.13392 11.6643 5.33313V10.9181C11.6639 11.9525 11.3477 12.9622 10.758 13.812C10.1684 14.6619 9.33327 15.3115 8.36444 15.6739C7.39562 16.0364 6.33923 16.0944 5.33653 15.8402C4.33384 15.5861 3.43263 15.0319 2.75341 14.2517C2.07419 13.4716 1.64933 12.5026 1.53566 11.4745C1.42198 10.4464 1.62489 9.40803 2.11727 8.49833C2.60964 7.58863 3.36801 6.85093 4.29097 6.38387C5.21392 5.91681 6.25747 5.74265 7.28207 5.88469V8.69375C6.81321 8.54627 6.30974 8.55072 5.84355 8.70644C5.37737 8.86217 4.97231 9.16123 4.68623 9.5609C4.40014 9.96057 4.24766 10.4404 4.25055 10.9319C4.25345 11.4234 4.41157 11.9014 4.70235 12.2977C4.99312 12.694 5.40167 12.9882 5.86966 13.1385C6.33765 13.2887 6.84114 13.2872 7.30823 13.1342C7.77532 12.9812 8.18213 12.6845 8.47055 12.2866C8.75898 11.8886 8.91427 11.4096 8.91426 10.9181V0H11.6643C11.6624 0.232231 11.6818 0.464146 11.7224 0.692813C11.8179 1.20328 12.0166 1.68888 12.3063 2.11992C12.596 2.55096 12.9705 2.91837 13.4071 3.19969C14.0281 3.61034 14.7563 3.82922 15.5008 3.82906V6.55969Z'
          fill='#191531'
        />
      </g>
      <defs>
        <clipPath id='clip0_200_8984'>
          <rect
            width='14'
            height='16'
            fill='white'
            transform='translate(1.50024)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}
